/**
 * @generated SignedSource<<50d6da21d1b14d7522ffc851978bb781>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselThumb_muxVideo$data = {
  readonly thumbnail: string | null;
  readonly " $fragmentType": "CarouselThumb_muxVideo";
};
export type CarouselThumb_muxVideo$key = {
  readonly " $data"?: CarouselThumb_muxVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselThumb_muxVideo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselThumb_muxVideo",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "height",
          "value": 75
        },
        {
          "kind": "Literal",
          "name": "width",
          "value": 100
        }
      ],
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": "thumbnail(height:75,width:100)"
    }
  ],
  "type": "VideoV2",
  "abstractKey": null
};

(node as any).hash = "d40e95319e46b838999303a2c1707926";

export default node;
